import {
  AGENTIC_AI_MODAL_DATA,
  AGENTIC_AI_MODAL_LANGUAGE_DATA,
  AGENTIC_AI_MODAL_PROMPT_DATA,
  EXTERNAL_TOOL_DATA
} from '../../common/actionTypes.js';
const INITIAL_STATE = {
  aiModels: [],
  languageModel: [],
  prompt: [],
  extTool: {}
};

const AgenticAiReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }

  switch (action.type) {
    case AGENTIC_AI_MODAL_DATA: {
      return {
        ...state,
        aiModels: action.payload
      };
    }

    case AGENTIC_AI_MODAL_LANGUAGE_DATA: {
      return {
        ...state,
        languageModel: action.payload
      };
    }

    case AGENTIC_AI_MODAL_PROMPT_DATA: {
      return {
        ...state,
        prompt: action.payload
      };
    }

    case EXTERNAL_TOOL_DATA: {
      return {
        ...state,
        extTool: action.payload
      };
    }

    default:
      return state;
  }
};

export default AgenticAiReducer;